import {
  AlertDialog, AlertDialogAction, AlertDialogCancel,
  AlertDialogContent, AlertDialogDescription, AlertDialogFooter,
  AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export function ConfirmDialog({ open, onConfirm, onCancel, title, description, confirmText = 'Confirm', destructive = false }) {
  const cleanTitle = (title || 'Are you sure?').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  const cleanDesc = description?.replace(/_/g, ' ') || '';

  return (
    <AlertDialog open={open} onOpenChange={v => { if (!v) onCancel(); }}>
      <AlertDialogContent data-testid="confirm-dialog" className="bg-white dark:bg-[var(--surface)] dark:border-[var(--line)] max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle data-testid="confirm-dialog-title" className="dark:text-white">{cleanTitle}</AlertDialogTitle>
          {cleanDesc && <AlertDialogDescription data-testid="confirm-dialog-description" className="dark:text-gray-400 whitespace-pre-line">{cleanDesc}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-row gap-2 sm:flex-row sm:justify-start">
          <AlertDialogAction
            data-testid="confirm-dialog-confirm"
            onClick={onConfirm}
            className={destructive ? 'bg-red-600 hover:bg-red-700 text-white' : 'bg-gray-900 dark:bg-white hover:bg-gray-800 dark:hover:bg-gray-200 text-white dark:text-black'}
          >
            {confirmText?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
          </AlertDialogAction>
          <AlertDialogCancel data-testid="confirm-dialog-cancel" onClick={onCancel} className="mt-0 dark:bg-transparent dark:border-[var(--line)] dark:text-gray-300 dark:hover:bg-[rgba(255,255,255,0.05)]">Cancel</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
